module.exports = {
  xxl: {
    type: {
      contrastInvert: {
        color: 'palette.contrastInvert',
        weight: '700',
      },
      regular: {
        color: 'palette.contrastHigh',
        weight: '700',
      },
    },
    size: '2.25rem',
    lineHeight: '2.5rem',
  },
  xl: {
    type: {
      contrastInvert: {
        color: 'palette.contrastInvert',
        weight: '500',
      },
      regular: {
        color: 'palette.contrastHigh',
        weight: '500',
      },
    },
    size: '1.5rem',
    lineHeight: '1.625rem',
  },
  lg: {
    size: '1.125rem',
    lineHeight: '1.375rem',
    type: {
      highContrast: {
        color: 'palette.contrastHigh',
        weight: '500',
      },
      lowContrast: {
        color: 'palette.contrastHigh',
        weight: '300',
      },
      url: {
        color: 'palette.primary',
        weight: '500',
      },
      contrastInvert: {
        color: 'palette.contrastInvert',
        weight: '500',
      },
      regular: {
        color: 'palette.contrastHigh',
        weight: '500',
      },
    },
  },
  md: {
    size: '1rem',
    lineHeight: '1.25rem',
    type: {
      highContrast: {
        color: 'palette.contrastHigh',
        weight: '500',
      },
      lowContrast: {
        color: 'palette.contrastHigh',
        weight: '300',
      },
      regular: {
        color: 'palette.contrastHigh',
        weight: '400',
      },
      url: {
        color: 'palette.primary',
        weight: '500',
      },
      contrastInvert: {
        color: 'palette.contrastInvert',
        weight: '500',
      },
    },
  },
  sm: {
    size: '0.875rem',
    lineHeight: '1.125rem',
    type: {
      highContrast: {
        color: 'palette.contrastHigh',
        weight: '500',
      },
      regular: {
        color: 'palette.contrastHigh',
        weight: '400',
      },
      lowContrast: {
        color: 'palette.contrastHigh',
        weight: '300',
      },
      url: {
        color: 'palette.primary',
        weight: '500',
      },
      success: {
        color: 'palette.successAlt',
        weight: '500',
      },
      warning: {
        color: 'palette.warningAlt',
        weight: '500',
      },
      error: {
        color: 'palette.errorAlt',
        weight: '500',
      },
      contrastInvert: {
        color: 'palette.contrastInvert',
        weight: '500',
      },
    },
  },
  xs: {
    size: '0.75rem',
    lineHeight: '1rem',
    type: {
      highContrast: {
        color: 'palette.contrastHigh',
        weight: '600',
      },
      regular: {
        color: 'palette.contrastHigh',
        weight: '400',
      },
      lowContrast: {
        color: 'palette.contrastHigh',
        weight: '300',
      },
      disabled: {
        color: 'palette.secondaryAlt',
        weight: '400',
      },
      url: {
        color: 'palette.primary',
        weight: '500',
      },
      success: {
        color: 'palette.successAlt',
        weight: '500',
      },
      warning: {
        color: 'palette.warningAlt',
        weight: '500',
      },
      error: {
        color: 'palette.errorAlt',
        weight: '500',
      },
      contrastInvert: {
        color: 'palette.contrastInvert',
        weight: '600',
      },
    },
  },
  xxs: {
    size: '0.625rem',
    lineHeight: '0.875rem',
    type: {
      highContrast: {
        color: 'palette.contrastHigh',
        weight: '500',
      },
      regular: {
        color: 'palette.contrastHigh',
        weight: '400',
      },
      disabled: {
        color: 'palette.secondaryAlt',
        weight: '400',
      },
      url: {
        color: 'palette.primary',
        weight: '500',
      },
      success: {
        color: 'palette.successAlt',
        weight: '500',
      },
      warning: {
        color: 'palette.warningAlt',
        weight: '500',
      },
      error: {
        color: 'palette.errorAlt',
        weight: '500',
      },
      contrastInvert: {
        color: 'palette.contrastInvert',
        weight: '500',
      },
    },
  },
};
